export const playNowLayoutId = 'play-now';
